/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useLocation} from "react-router";
import {NavLink} from "react-router-dom";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";
import SVG from "react-inlinesvg";

export function GeneralHeaderMenu({ layoutProps }) {
    const location = useLocation();
    const getMenuItemActive = (url) => {
        return checkIsActive(location, url) ? "menu-item-active" : "";
    }

    return <div
        id="od_header_menu"
        className={`ml-2 header-menu header-menu-mobile ${layoutProps.odMenuClasses}`}
        {...layoutProps.headerMenuAttributes}
    >
        {/*begin::Header Nav*/}
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>

            {/*Classic submenu*/}
            {/*begin::1 Level*/}
            <li data-menu-toggle={layoutProps.menuDesktopToggle}
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/custom')}`}>
                <span className="menu-link menu-toggle" to="/custom">
                    <span className="menu-text">Tools</span>
                    <i className="menu-arrow"></i>
                </span>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
                        {/*begin::2 Level*/}
                        <li className={`menu-item ${getMenuItemActive('/builder')}`}>
                            <NavLink className="menu-link" to="/builder">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")} title="GPS Tracking"/>
                                </span>
                                <span className="menu-text">GPS Tracking</span>
                            </NavLink>
                        </li>

                        <li className={`menu-item ${getMenuItemActive('/builder')}`}>
                            <NavLink className="menu-link" to="/builder">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Lock-overturning.svg")} title="Pass Safe"/>
                                </span>
                                <span className="menu-text">Pass Safe</span>
                            </NavLink>
                        </li>

                        <li className={`menu-item ${getMenuItemActive('/builder')}`}>
                            <NavLink className="menu-link" to="/builder">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Binocular.svg")} title="IT Solutions"/>
                                </span>
                                <span className="menu-text">IT Solutions</span>
                            </NavLink>
                        </li>

                        <li className={`menu-item ${getMenuItemActive('/builder')}`}>
                            <NavLink className="menu-link" to="/builder">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Tools/Pantone.svg")} title="IT Policies"/>
                                </span>
                                <span className="menu-text">IT Policies</span>
                            </NavLink>
                        </li>

                        <li className={`menu-item ${getMenuItemActive('/builder')}`}>
                            <NavLink className="menu-link" to="/builder">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Call.svg")} title="Oncall Users"/>
                                </span>
                                <span className="menu-text">Oncall Users</span>
                            </NavLink>
                        </li>
                        {/*end::2 Level*/}
                    </ul>
                </div>
            </li>
            {/*end::1 Level*/}
        </ul>
        {/*end::Header Nav*/}
    </div>;
}
